import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppIconComponent } from '../../shared/components/app-icon/app-icon.component';
import { SidebarComponent } from '../../shared/components/sidebar/sidebar.component';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [SidebarComponent, RouterOutlet, AppIconComponent],
  template: `
    <div class="admin-layout">
      <div
        class="admin-layout__overlay"
        [class.admin-layout__overlay--visible]="sidebarOpen()"
        (click)="closeSidebar()"
        aria-hidden="true"
      ></div>

      <app-sidebar [isOpen]="sidebarOpen()" (closed)="closeSidebar()" />

      <div class="admin-layout__main">
        <header class="admin-layout__mobile-header">
          <button
            type="button"
            class="admin-layout__menu-btn"
            (click)="toggleSidebar()"
            [attr.aria-expanded]="sidebarOpen()"
            aria-label="Toggle navigation menu"
          >
            <app-icon [name]="sidebarOpen() ? 'x' : 'menu'" [size]="22" />
          </button>
          <div class="admin-layout__mobile-brand">
            <span class="admin-layout__mobile-brand-name">VASELINE</span>
            <span class="admin-layout__mobile-brand-subtitle">Gluta-Hya Admin</span>
          </div>
        </header>

        <main class="admin-layout__content">
          <router-outlet />
        </main>
      </div>
    </div>
  `,
  styles: `
    @use 'styles/variables' as *;

    .admin-layout {
      min-height: 100vh;
      background: $color-bg;
      width: 100%;
      overflow-x: hidden;
    }

    .admin-layout__overlay {
      display: none;
    }

    .admin-layout__main {
      min-height: 100vh;
      margin-left: $sidebar-width;
      width: calc(100% - #{$sidebar-width});
    }

    .admin-layout__mobile-header {
      display: none;
    }

    .admin-layout__content {
      min-height: 100vh;
      padding: $spacing-xl;
    }

    .admin-layout__mobile-brand {
      display: flex;
      align-items: baseline;
      gap: $spacing-sm;
    }

    .admin-layout__mobile-brand-name {
      font-size: 1rem;
      font-weight: 800;
      color: $color-primary;
      letter-spacing: 0.12em;
    }

    .admin-layout__mobile-brand-subtitle {
      font-size: 0.8125rem;
      color: $color-text-muted;
    }

    @media (max-width: $breakpoint-sidebar) {
      .admin-layout__overlay--visible {
        display: block;
        position: fixed;
        inset: 0;
        background: rgba(0, 35, 70, 0.45);
        z-index: 99;
      }

      .admin-layout__main {
        margin-left: 0;
        width: 100%;
      }

      .admin-layout__mobile-header {
        display: flex;
        align-items: center;
        gap: $spacing-md;
        width: 100%;
        padding: $spacing-md;
        background: $color-card;
        border-bottom: 1px solid $color-border;
        position: sticky;
        top: 0;
        z-index: 50;
        box-sizing: border-box;
      }

      .admin-layout__menu-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: $radius-sm;
        color: $color-text;
        flex-shrink: 0;
        transition: background 0.15s;

        &:hover {
          background: $color-blush-soft;
        }
      }

      .admin-layout__content {
        padding: $spacing-md;
        min-height: calc(100vh - 65px);
      }
    }
  `,
})
export class AdminLayoutComponent {
  readonly sidebarOpen = signal(false);

  toggleSidebar(): void {
    this.sidebarOpen.update((open) => !open);
  }

  closeSidebar(): void {
    this.sidebarOpen.set(false);
  }
}
